import React, { useRef, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import MaterialExTable from "../../../../components/tables/MaterialExTable";
import { ArrowDownCircleIcon } from "@heroicons/react/24/solid";
import { CSVLink } from "react-csv";
import useGetBusinessLicensePermit from "./hooks/useGetBusinessLicensePermit";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import { IdentificationIcon } from "@heroicons/react/24/solid";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import DownloadButton from "../../../../components/DownloadButton";

interface BusinessLicensesPermitsReportWestBUProps {}
export const BusinessLicensesPermitsReportWestBU: React.FC<BusinessLicensesPermitsReportWestBUProps> =
  () => {
    const searchInputsData = {
      BlpReportsWestBU: true,
    };

    const { data: busLicencePermit, isLoading: busLicencePermitLoading } =
      useGetBusinessLicensePermit(searchInputsData);
    const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
    const history = useHistory();
    const userPermissions = useRecoilValue(permissionsSelector);
    // const busLicencePermit = useBusLicencePermit();

    let today = new Date().toLocaleString();

    const GetDaysBetweenDates = (d0, d1) => {
      let msPerDay = 8.64e7;
      let x0 = new Date(d0);
      let x1 = new Date(d1);
      return Math.round(
        (x0.setHours(12, 0, 0) - x1.setHours(12, 0, 0)) / msPerDay
      );
    };

    // const filteredScorecard = searchScorecard?.filter((x) =>
    //   x.closedDate
    //     ? GetDaysBetweenDates(x.closedDate, x.createdDate)
    //     : GetDaysBetweenDates(today, x.createdDate) >= 14
    // );
    function formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [month, day, year].join("/");
    }

    interface IBusinessLicensesPermitsReport {
      legalEntity: string;
      brand: string;
      storeNumber: string;
      officeCode: string;
      fromOfficeName: string;
      address: string;
      city: string;
      state: string;
      zipCode: string;
      busLicensePermitTypeName: string;
      notes: string;
      licenseOrPermitNumber: string;
      expirationDate: string;
      officeStatus: string;
      officeType: string;
      officeStatusDetails: string;
      office_Opened_Date: string;
      office_Closed_Date: string;
    }

    const [selectedRows, setSelectedRows] = useState([]);
    //For downloading table data
    const exportdata = busLicencePermit?.data?.map(
      (blpmt: IBusinessLicensesPermitsReport) => {
        const licenseOrPermitNumber = blpmt.licenseOrPermitNumber?.includes(
          "\n"
        )
          ? blpmt.licenseOrPermitNumber.replaceAll("\n", " ")
          : blpmt.licenseOrPermitNumber;

        return {
          "Legal Entity": blpmt.legalEntity,
          Brand: blpmt.brand,
          "Corporate Office #": blpmt.storeNumber,
          "Office Code": blpmt.officeCode,
          "Office Name": blpmt.fromOfficeName,
          Address: blpmt.address,
          City: blpmt.city,
          State: blpmt.state,
          ZipCode: blpmt.zipCode,
          Type: blpmt.busLicensePermitTypeName,
          Notes: blpmt.notes?.includes("\n")
            ? blpmt.notes.replaceAll("\n", " ")
            : blpmt.notes,
          "Expiration Date": blpmt.expirationDate
            ? formatDate(blpmt.expirationDate)
            : "",
          "Office Status": blpmt.officeStatus,
          OfficeType: blpmt.officeType,
          "Office Status Detail": blpmt.officeStatusDetails,
          "Office Opened Date": blpmt.office_Opened_Date
            ? formatDate(blpmt.office_Opened_Date)
            : "",
          "Office Closed Date": blpmt.office_Closed_Date
            ? formatDate(blpmt.office_Closed_Date)
            : "",
          "License/Permit #": licenseOrPermitNumber,
        };
      }
    );

    let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
    const csvReport = {
      filename: "BusinessLicensesPermitsReportWestBU_" + dateTimeToday + ".csv",
      data: exportdata ? exportdata : [],
    };

    const matColumns = [
      {
        title: "Legal Entity",
        field: "legalEntity",
      },
      {
        title: "Corporate Office #",
        field: "storeNumber",
      },
      {
        title: "Office Code",
        field: "officeCode",
      },
      {
        title: "Office Name",
        field: "fromOfficeName",
        render: (rowData) => {
          return (
            <div
              className="cursor-pointer"
              onClick={() => {
                const url = "/officesettings/officesetting";
                history.push({
                  pathname: url,
                  state: {
                    pathname: url,
                    officeCode: rowData?.officeCode,
                    action: "BLPWBUReports",
                  },
                });
                window.location.reload();
                let userTabs = [
                  {
                    to: "",
                  },
                ];
                [...OfficeTabs].forEach((tabs) => {
                  let temp = [...userPermissions].filter(
                    (user) => user === tabs.permission
                  );
                  if (temp.length > 0)
                    userTabs.push({
                      to: tabs.to,
                    });
                });
                userTabs.shift();
                const index = userTabs.findIndex((c) => c.to === url);
                setSelectedIndex(index);
              }}
            >
              <span className="text-quinary  font-bold underline text-sm ">
                {rowData.fromOfficeName}
              </span>
            </div>
          );
        },
      },
      {
        title: "Address",
        field: "address",
      },
      {
        title: "City",
        field: "city",
      },
      {
        title: "State",
        field: "state",
      },
      {
        title: "Zip Code",
        field: "zipCode",
      },
      {
        title: "Type",
        field: "busLicensePermitTypeName",
      },
      {
        title: "Notes",
        field: "notes",
      },
      {
        title: "License/Permit Number",
        field: "licenseOrPermitNumber",
        render: (rowData) => {
          const license = rowData.licenseOrPermitNumber.replace(/"/g, "");
          return license;
        },
      },
      {
        title: "Expiration Date",
        field: "expirationDate",
        render: (rowData) =>
          rowData.expirationDate ? formatDate(rowData.expirationDate) : "",
      },
      {
        title: "Office Status",
        field: "officeStatus",
      },
      {
        title: "Office Type",
        field: "officeType",
      },
      {
        title: "office Status Details",
        field: "officeStatusDetails",
      },

      {
        title: "Office Opened Date",
        field: "office_Opened_Date",
        render: (rowData) => {
          return (
            <div>
              {rowData.office_Opened_Date
                ? formatDate(rowData.office_Opened_Date)
                : ""}
            </div>
          );
        },
      },

      {
        title: "Office Closed Date",
        field: "office_Closed_Date",
        render: (rowData) => {
          return (
            <div>
              {rowData.office_Closed_Date
                ? formatDate(rowData.office_Closed_Date)
                : ""}
            </div>
          );
        },
      },
    ];

    return (
      <div className="text-xs items-center">
        <div className="">
          <div className="mx-4 mt-4 overflow-x-auto">
            <div className="flex mb-2 gap-2 items-center">
              <div>
                <IdentificationIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
              </div>
              <div className="flex flex-col leading-tight">
                <div className="text-gray-500 text-md font-medium">
                  Report: Business Licenses And Permits{" "}
                </div>
                <div className="flex items-center font-bold text-lg text-primary">
                  {"Business License Listing - West BU"}
                </div>
              </div>
            </div>
            <div className="mt-2" />
            <div className="flex justify-between mb-2 mr-2">
              <div className="flex items-center gap-1">
                <span className="text-gray-500 text-sm">Total Records: </span>
                <span className="text-primary text-base font-semibold">
                  {busLicencePermit?.data?.length}
                </span>
              </div>

              <CSVLink {...csvReport}>
                <DownloadButton
                  buttonValue="Download File"
                  onClick={() => exportdata()}
                  className={undefined}
                  disabled={undefined}
                />
              </CSVLink>
            </div>
          </div>
          <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
            <MaterialTableTS
              data={busLicencePermit?.data}
              isLoading={busLicencePermitLoading}
              columns={matColumns}
              showTitle={false}
            />
          </div>
        </div>
      </div>
    );
  };
